// Lightweight Google Analytics (gtag) event tracker.
// Falls back silently if gtag isn't loaded (e.g. ad blockers).

type GtagCommand = "event" | "config" | "set" | "consent";

interface GtagWindow extends Window {
  gtag?: (
    command: GtagCommand,
    eventName: string,
    params?: Record<string, unknown>,
  ) => void;
}

/**
 * Fire a GA4 custom event. Safe to call even before gtag loads.
 */
export function trackEvent(
  eventName: string,
  params: Record<string, unknown> = {},
) {
  if (typeof window === "undefined") return;
  const w = window as GtagWindow;
  if (typeof w.gtag === "function") {
    w.gtag("event", eventName, params);
  }
}

/** Track a click-to-call action. */
export function trackCall(phone: string, location: string) {
  trackEvent("click_to_call", {
    phone_number: phone,
    link_location: location,
  });
}

/** Track a click-to-email action. */
export function trackEmail(email: string, location: string) {
  trackEvent("click_to_email", {
    email_address: email,
    link_location: location,
  });
}

/** Track a WhatsApp button click. */
export function trackWhatsApp(location: string) {
  trackEvent("click_to_whatsapp", {
    link_location: location,
  });
}

/** Track a quote / form CTA click. */
export function trackQuote(location: string) {
  trackEvent("click_to_quote", {
    link_location: location,
  });
}
